import { render, staticRenderFns } from "./Phonebook_editor.vue?vue&type=template&id=6a22d108"
import script from "./Phonebook_editor.vue?vue&type=script&lang=js"
export * from "./Phonebook_editor.vue?vue&type=script&lang=js"
import style0 from "./Phonebook_editor.vue?vue&type=style&index=0&id=6a22d108&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports